const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export function getToken() {
  return localStorage.getItem('effekt_token');
}

export function setToken(token) {
  localStorage.setItem('effekt_token', token);
}

export function clearToken() {
  localStorage.removeItem('effekt_token');
}

export function isLoggedIn() {
  return !!getToken();
}

function authHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function api(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...options.headers
    }
  });
  return res;
}

export async function login(password) {
  const res = await api('/api/login', {
    method: 'POST',
    body: JSON.stringify({ password })
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error || 'Innlogging feilet');
  }
  const { token } = await res.json();
  setToken(token);
  return token;
}

export async function verifyAuth() {
  try {
    const res = await api('/api/auth/verify');
    return res.ok;
  } catch {
    return false;
  }
}
